import React from 'react';
import PropTypes from 'prop-types';

import Card from 'components_v2/common/CardV2/Card';
import s from './LongCard.scss';

const LongCard = props => {
  const { data, userData } = props;

  if (!data?.items || !data.items?.length) {
    return null;
  }
  return (
    <div className={s.longCard}>
      {data.items.map(el => (
        <Card
          data={el}
          showDescription
          isVerticalTile
          timeStampHtml
          imgWidth="500"
          istoipListing
          isLongCard
          isHomeListing
          gaPageName="TOIPlus_HomePage"
          tpPageName="toiphome"
          userData={userData}
        />
      ))}
    </div>
  );
};

LongCard.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  userData: PropTypes.shape({}),
};

LongCard.defaultProps = {
  data: [],
  userData: undefined,
};

export default LongCard;
